import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { FormGroup, Validators } from "@angular/forms";
import { map } from "rxjs/operators";
import { SubSink } from "subsink";
import { AutomapperService } from "../../../../../core/automapper/automapper.service";
import { FormService } from "../../../../../dynamic-forms/form.service";
import { Dropdown } from "../../../../../dynamic-forms/inputs/dropdown/dropdown.model";
import { StringHelper } from "../../../../../utilities/contracts/string-helper";
import { ChaseQueryService } from "../../chase-query/chase-query.service";

@Component({
  selector: "app-chart-delivery",
  templateUrl: "./chart-delivery.component.html",
  styleUrls: ["./chart-delivery.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartDeliveryComponent implements OnInit, OnChanges, OnDestroy {
  @Input() projectConfigForm: FormGroup;
  @Input() projectAttributes: any;

  formGroup: FormGroup;
  chaseChartDeliveryStatus: Dropdown;
  private sink = new SubSink();

  constructor(
    private readonly formService: FormService,
    private readonly automapper: AutomapperService,
    private readonly chaseQueryService: ChaseQueryService,
    private readonly changeDetector: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.projectConfigForm.addControl("chartDeliveryFormGroup", this.formGroup);
    this.getStatuses();

    if (this.projectAttributes) {
      this.loadChartDeliverySettings();
    }
  }

  ngOnChanges(): void {
    if (this.projectAttributes && this.formGroup) {
      this.loadChartDeliverySettings();
    }
  }

  ngOnDestroy(): void {
    this.sink.unsubscribe();
  }

  saveTo(projectAttributes: any): void {
    projectAttributes.ChaseChartDeliveryStatus.attributeValue = this.formGroup.get("chaseChartDeliveryStatus").value;
  }

  private createForm(): void {
    this.chaseChartDeliveryStatus = new Dropdown({
      key: "chaseChartDeliveryStatus",
      label: "Chase status for delivery:",
      placeholder: "Available for Download",
      validators: [Validators.required],
      errorMessages: {
        required: "Chase status for delivery is required.",
      },
    });

    this.formGroup = this.formService.createFormGroup([
      this.chaseChartDeliveryStatus,
    ]);
  }

  private getStatuses(): void {
    this.sink.add(this.chaseQueryService
      .getReportingStatusesList(false)
      .pipe(
        map(this.automapper.curryMany("ChaseReportingStatusModel", "SelectableInput")),
        map((options: any[]) =>
          options.filter(option => ["Available for Download", "Data Entry", "Overread", "Client Overread", "Client Overread 2"].includes(option.value))
        )
      )
      .subscribe((options: any[]): void => {
        options.forEach(o => { o.text = o.text?.replace(/Client Overread ?2?/, "Overread II"); });
        this.chaseChartDeliveryStatus = new Dropdown({ ...this.chaseChartDeliveryStatus, options } as any);
        this.changeDetector.markForCheck();
      }));
  }

  private loadChartDeliverySettings(): void {
    const chaseDeliveryValue = StringHelper.isAvailable(this.projectAttributes.ChaseChartDeliveryStatus?.attributeValue);

    this.formGroup.patchValue({
      chaseChartDeliveryStatus: chaseDeliveryValue
        ? this.projectAttributes.ChaseChartDeliveryStatus.attributeValue
        : "Available for Download",
    });
    this.changeDetector.markForCheck();
  }
}
